import { MessageSquare, Settings, Users } from 'lucide-react';

import { XLogo } from '@/components/icons';

import type { Platform } from '@/types/navigation';
import type { RouteObject } from 'react-router-dom';

export const xRoutes: RouteObject[] = [
  {
    path: 'x',
    children: [
      {
        index: true,
        lazy: async () => {
          const { ReplyQueuePage } = await import('./pages/ReplyQueuePage');
          return { Component: ReplyQueuePage };
        },
      },
      {
        path: 'accounts',
        lazy: async () => {
          const m = await import('./pages/MonitoredAccountsPage');
          return { Component: m.MonitoredAccountsPage };
        },
      },
      {
        path: 'settings',
        lazy: async () => {
          const { SettingsPage } = await import('./pages/SettingsPage');
          return { Component: SettingsPage };
        },
      },
    ],
  },
];

export const xPlatform: Platform = {
  id: 'x',
  label: 'X',
  icon: XLogo,
  features: [
    {
      id: 'followup-tweets',
      label: 'Followup Tweets',
      items: [
        {
          id: 'reply-queue',
          label: 'Reply Queue',
          path: '/x',
          icon: MessageSquare,
        },
        { id: 'accounts', label: 'Accounts', path: '/x/accounts', icon: Users },
        {
          id: 'settings',
          label: 'Settings',
          path: '/x/settings',
          icon: Settings,
        },
      ],
    },
  ],
};
